import { Fragment, useContext, useEffect, useMemo, useState } from "react";
import FavIcon from "../../../assets/svg/FavIcon";
import FormStep from "../../../services/models/formModels/MultiStepForm/formStep.model";
import CustomText from "../../atomic/CustomText";
import CustomAccordion from "../../organism/CustomAccordion";
import useTestsList from "../../../services/utils/custom hooks/OnlineOrder/useTestsList";
import OnlineOrderActions from "../../../services/OnlineOrderActions";
import SelectTestCardProps from "../../../services/models/selectTestCardProps.model";
import TestListModel from "../../../services/models/testList.model";
import useProfile from "../../../services/utils/custom hooks/useProfile";
import SelectTestLoadingIndicator from "../LoadingIndicators/OnlineOrder/SelectTestLoadingIndicator";
import SelectTestCard from "../SelectTestCard";
import toastMessages from "../../../services/utils/helpers/toastMessage";
import useVerifySOF from "../../../services/utils/custom hooks/OnlineOrder/useVerifySOF";
import { useOktaAuth } from "@okta/okta-react";
import axiosInstance from "../../../services/api";
import CustomPopUp from "../CustomPopup";
import Button from "../../organism/Button";
import { useHistory } from "react-router-dom";
import OnlineOrderValuesModel from "../../../services/models/formModels/onlineOrderValues.model";
import useFavoriteTestLists from "../../../services/utils/custom hooks/OnlineOrder/useFavoriteTestsList";
import useMarkFavoriteTest from "../../../services/utils/custom hooks/OnlineOrder/useMarkFavoriteTest";
import useMarkUnfavoriteTest from "../../../services/utils/custom hooks/OnlineOrder/useMarkUnfavoriteTest";
import { PopUpContext } from "../../../services/context/popupContext";
import CreatePatientPopup from "../../popups/createPatientPopup";
import OnlineOrderPopupValues from "../../../services/models/formModels/onlineOrderPopupValues.model";
import IDGDiscontinuationPopup from "../../popups/IDGDiscountinuationPopup";
import { ApplicationState } from "../../../services/context/ApplicationStateContext";

function FavTests({
  testsList,
  values,
  handleSelection,
  favTests,
  unFavorite,
}: {
  testsList: TestListModel[];
  values: OnlineOrderValuesModel;
  handleSelection: any;
  favTests: any;
  unFavorite: any;
}): JSX.Element {
  const history = useHistory();
  if (favTests && favTests?.data?.length > 0)
    return (
      <div className="py-4 border-b">
        <CustomText
          text="Your Favorite Tests"
          fontWeight="font-normal"
          fontSize="text-sm"
          className="capitalize mb-5"
        />

        <div className="flex flex-wrap">
          {testsList.map((testSection, index) => (
            <div className="flex" key={`fav${testSection.title}` + index}>
              {testSection.tests
                .filter((test) => {
                  let pathName = history.location.pathname
                  return pathName.split('/')[3] && values?.testTypeId == 8 ? favTests?.data?.find((favTest: any) => favTest.id === test.id) : favTests?.data?.find((favTest: any) => favTest.id === test.id) && test.id !== 8
                }
                )
                .map((test, testIndex) => {
                  return (
                    <SelectTestCard
                      key={test.id + test.testName}
                      {...test}
                      values={values}
                      isFavorite
                      handleFav={() => unFavorite({ id: test.id })}
                      selected={
                        values.testTypeId == test.id ||
                        values.secondaryTestId == test.id
                      }
                      handleSelection={handleSelection(test)}
                    />
                  );
                })}
            </div>
          ))}
        </div>
      </div>
    );
  return <Fragment />
}

function SelectTestStep({
  errors,
  touched,
  setFieldValue,
  setFieldError,
  values,
  setFieldTouched,
}: FormStep) {
  const profile = useProfile();
  const [activeIndex, setActiveIndex] = useState<any>(null);
  const oktaAuth = useOktaAuth();
  const handleQuestionClick = (index: any) => {
    return () => setActiveIndex(activeIndex === index ? null : index);
  };
  const { data, isLoading } = useTestsList();
  const [testsList, setTestList] = useState<TestListModel[]>([]);
  const [previousTestId, setPreviousTestId] = useState<number | null>(null);
  const { authState } = useOktaAuth();
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [showDuplicatePopup, setShowDuplicatePopup] = useState<boolean>(false);
  const [orderId, setOrderId] = useState<string>("");
  const {
    state: { selectedOrganization, selectedPhysician, selectedPhysicianData, selectedPathLab },
  } = useContext(ApplicationState);
  const history = useHistory();
  const {
    data: favTests,
    isLoading: fetchingFavTests,
    refetch,
  } = useFavoriteTestLists();
  const { mutate, isPending, isSuccess } = useMarkFavoriteTest();
  const { mutate: unFavorite, isSuccess: unFavSuccess } =
    useMarkUnfavoriteTest();

  const { visible, setVisible, setPopUp, setPopUpTitle } =
    useContext(PopUpContext);
  const verifySOF = useVerifySOF();
  const onlineOrderActions = new OnlineOrderActions(
    selectedOrganization,
    selectedPhysician,
    selectedPhysicianData,
    profile?.data?.user?.roles ?? [],
    profile?.data?.user?.id ?? ""
  );
  const orderActions = new OnlineOrderActions(
    selectedOrganization,
    selectedPhysician,
    selectedPhysicianData,
    profile?.data?.user?.roles ?? [],
    profile?.data?.user?.id ?? "")



  function updateOnlineOrderValues(data: OnlineOrderPopupValues) {
    Object.keys(data).forEach((key: string) => {
      type ValueKey = keyof typeof data;
      const myKey = key as ValueKey;
      if (key !== "testTypeId") {
        setFieldValue(`patientInfo.${key}`, data?.[myKey]);
        setFieldTouched(`patientInfo.${key}`, true);
      }
    });
  }

  function openPatientPopup(testTypeId: number) {
    setVisible(!visible);
    setPopUpTitle("Create a Patient");
    setPopUp(
      <CreatePatientPopup
        oktaAuth={oktaAuth}
        patientInformation={{
          ...values.patientInfo,
          testTypeId,
        }}
        setOnlineOrderValues={updateOnlineOrderValues}
        initialStep={3}
      />
    );
  }
  function openDiscontinuationPopup() {
    setVisible(!visible);
    setPopUpTitle("Notice");
    setPopUp(
      <IDGDiscontinuationPopup
        handlePopupClose={() => setVisible(false)} />
    );
  }
  function handleSOFError(error: any) {
    const errors: any = {
      noSOF: {
        type: "error",
        message: (
          <div>
            <span className="font-semibold text-royalBlue">
              Signature on File Does Not Exist:
            </span>
            <br />
            <span>
              {" "}
              The clinician selected does not have a Signature on File (SOF)
              with Castle. Please submit a SOF to be authorized to order.
            </span>
          </div>
        ),

      },
      isExpiredSOF: {
        type: "error",
        message: (
          <div>
            <span className="font-semibold text-royalBlue">
              Signature on File Expired:
            </span>
            <br />
            <span>
              {" "}
              The Signature on File for the selected clinician has expired. This
              order can be submitted but Castle must obtain an updated
              authorization.
            </span>
          </div>
        ),

      },
      sofMismatch: {
        type: "error",
        message: (
          <div>
            <span className="font-semibold text-royalBlue">
              Signature on File Test Mismatch:
            </span>
            <br />
            <span>
              {" "}
              The clinician selected does not have a Signature on File for the
              selected Castle test. This order cannot be submitted and an updated
              authorization must be obtained.
            </span>
          </div>
        ),
      },
    };
    // To access Object key's
    type ObjectKey = keyof typeof errors;
    const myKey = error as ObjectKey;
    toastMessages.warning(errors[myKey].message);
  }
  function setTypeOfSpecimen(testId: number) {
    switch (testId) {
      case 8:
        setFieldValue("laboratoryInfo.typeOfSpecimen", "Buccal Swab", true)
        setFieldTouched("laboratoryInfo.typeOfSpecimen", true)
        break;

      case 4:
      case 7:
        setFieldValue("laboratoryInfo.typeOfSpecimen", "Fine Needle Aspiration Biopsy", true)
        setFieldTouched("laboratoryInfo.typeOfSpecimen", true)
        break

      default:
        setFieldValue("laboratoryInfo.typeOfSpecimen", "Slides from Formalin Fixed Paraffin Embedded Tumor Tissue", true)
        setFieldTouched("laboratoryInfo.typeOfSpecimen", true)
        break;
    }
  }
  function handleSelection(test: SelectTestCardProps) {
    return () => {
      const roles = profile?.data?.user?.roles ?? [];
      const userId = profile?.data?.user?.id;
      const isDualRole = roles.length > 1 && roles.includes("Physician");
      const isDualRoleAndPhysicianHimself = isDualRole && values?.physicianId == userId;
      const onlyPhysicianRole = roles.length === 1 && roles.includes("Physician");
      const skipSOFCheck = onlyPhysicianRole || roles.includes("Collaborative Order Agreement") || isDualRoleAndPhysicianHimself;

      if (!skipSOFCheck) {
        verifySOF.mutate(
          {
            physicianId: values.physicianId,
            primaryTest: test.id,
            secondaryTest: values.secondaryTestId,
          },
          {
            onSuccess: (response) => {
              const sofData = response.data?.data || {};
              /* Using Find last because B.E is sending SOFMismatch key in the last, but it's precedence is at the top. Using this shows correct toast message*/
              let errorType = Object.keys(sofData).findLast(
                (key: string) => sofData[key] === true
              );

              // if (errorType) {
              //   handleSOFError(errorType);
              // }

              for (const key in sofData) {
                setFieldValue(key, sofData[key]);
                setFieldTouched(key, true);
              }
            },
            onError: (error: any) => {
              console.error("SOF verification error:", error);
            },
          }
        );
      }

      onlineOrderActions.resetValues(
        test.id,
        setFieldValue,
        setFieldTouched,
        previousTestId ?? -1
      );

      if (isDualRoleAndPhysicianHimself) {
        setFieldValue("noSOF", false);
        setFieldValue("isExpiredSOF", false);
        setFieldValue("sofMismatch", false);
        setFieldTouched("noSOF", true);
        setFieldTouched("isExpiredSOF", true);
        setFieldTouched("sofMismatch", true);
      }

      const currentTestTypeId = Number(values.testTypeId);
      let nextTestTypeId = Number(test.id);
      if (values.testTypeId) {
        if (test.groupId === values.testTypeId) {
          setFieldValue("secondaryTestId", test.id, true);
          nextTestTypeId = currentTestTypeId;
        } else {
          setFieldValue("testTypeId", test.id, true);
          setFieldValue("secondaryTestId", "", true);
          nextTestTypeId = Number(test.id);
        }
      } else {
        setFieldValue("testTypeId", test.id, true);
      }

      setTypeOfSpecimen(test.id)
      setFieldTouched("testTypeId", true);
      setPreviousTestId(values.testTypeId);
      if (test.id === 4 || test.id === 7) {
        if (
          values?.patientInfo?.securityInfo?.ssn === "" &&
          values?.patientInfo?.securityInfo?.mrn === ""
        ) {
          openPatientPopup(test.id);
        }
      }
      if (test.id === 8) {
        openDiscontinuationPopup()
      }

      const hasPatientInfoForConflictChecks =
        !!values?.patientInfo?.birthDate &&
        !!values?.patientInfo?.firstName &&
        !!values?.patientInfo?.lastName;
      const isPrimaryTestTypeSelectionOrChange =
        !currentTestTypeId || currentTestTypeId !== nextTestTypeId;

      if (hasPatientInfoForConflictChecks && isPrimaryTestTypeSelectionOrChange) {
        runOrderConflictChecks({
          patientId: values.patientId,
          testTypeId: nextTestTypeId,
        });
      }


    };
  }

  function sendSupportEmail() {
    setFieldValue("isPotentialDuplicateOrder", false);
    setShowDuplicatePopup(false);
    setVisible(false);
    history.replace({
      pathname: "/access/dashboard",
      state: { skipDiscardPopup: true },
    });
    window.location.href = "mailto:clinicalservices@castlebiosciences.com";
  }

  async function detectPending(
    patientId: string,
    testTypeId: number
  ): Promise<boolean> {
    try {
      const { data } = await axiosInstance.get(
        `/v1/patients/pending-order?patientId=${patientId}&testTypeId=${testTypeId}${values.id ? `&orderId=${values.id}` : ""
        }`,
        {
          headers: {
            Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
          },
        }
      );
      const { isExist, orderId } = data?.data;

      if (isExist) {
        setShowPopup(true);
        setShowDuplicatePopup(false);
        setOrderId(orderId);
        setVisible(false)
        return true;
      }
      return false;
    } catch (error: any) {
      toastMessages.error(error.message ?? error);
      return false;
    }
  }

  async function checkDuplicate(
    testTypeId: number,
    {
    suppressDuplicatePopup = false,
  }: {
    suppressDuplicatePopup?: boolean;
  } = {}
  ): Promise<void> {
    try {
      const payload = {
        patientDOB: values?.patientInfo?.birthDate,
        patientFirstName: values?.patientInfo?.firstName,
        patientLastName: values?.patientInfo?.lastName,
        testTypeId: String(testTypeId ?? ""),
      };

      const { data } = await axiosInstance.post(
        "/v1/orders/new-flow/check-duplicate",
        payload,
        {
          headers: {
            Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
          },
        }
      );
      const { hasDuplicate } = data?.data ?? {};

      if (hasDuplicate && !suppressDuplicatePopup) {
        setFieldValue("isPotentialDuplicateOrder", false);
        setShowPopup(false);
        setShowDuplicatePopup(true);
      } else {
        setShowDuplicatePopup(false);
      }
    } catch (error: any) {
      toastMessages.error(error.message ?? error);
    }
  }

  async function runOrderConflictChecks({
    patientId,
    testTypeId,
  }: {
    patientId?: string;
    testTypeId: number;
  }): Promise<void> {
    let hasPendingOrder = false;
    if (patientId) {
      hasPendingOrder = await detectPending(patientId, testTypeId);
    }
    await checkDuplicate(testTypeId, {
      suppressDuplicatePopup: hasPendingOrder,
    });
  }

  // useEffect(() => {
  //   if (data && data?.data?.length > 0) {
  //     setTestList(onlineOrderActions.getTestList(data, activeIndex).filter((test) => {
  //       let pathName = history.location.pathname
  //       return pathName.split('/')[3] && values?.testTypeId === 8 ? true : test.title !== "Mental Health"
  //     }));
  //   }
  // }, [isLoading, data, values.testTypeId, history.location.pathname]);
  useEffect(() => {
    const hasData = data && data?.data?.length > 0;

    if (hasData) {
      const filteredList = onlineOrderActions.getTestList(data, activeIndex).filter((test) => {
        let pathName = history.location.pathname;
        return pathName.split('/')[3] && values?.testTypeId === 8
          ? true
          : test.title !== "Mental Health";
      });
      setTestList(filteredList);
    } else {
      setTestList([]);
    }
  }, [
    isLoading,
    data,
    values.testTypeId,
    history.location.pathname,
    selectedPhysician,
    selectedOrganization
  ]);

  useEffect(() => {
    refetch();
  }, [isSuccess]);

  if (isLoading || fetchingFavTests) {
    return <SelectTestLoadingIndicator />;
  }

  function handleFav(isFav: boolean, testTypeId: number) {
    if (!isFav) {
      mutate({ testTypeId });
    } else {
      unFavorite({ id: testTypeId });
    }
  }

  return (
    <Fragment>
      <div>
        <FavTests
          testsList={testsList}
          values={values}
          handleSelection={handleSelection}
          favTests={favTests}
          unFavorite={unFavorite}
        />
        <div className="mt-4">
          <CustomText text="All Tests" fontWeight="font-normal" fontSize="text-sm" />
          {testsList.map((testSection, index) => (
            <CustomAccordion
              key={testSection.title}
              index={index}
              activeIndex={activeIndex}
              handleQuestionClick={handleQuestionClick?.(index)}
              title={testSection.title}
              allExpanded
            >
              <div className="flex flex-wrap">
                {testSection.tests.map((test, testIndex) => {
                  return (
                    <SelectTestCard
                      key={test.id + test.testName}
                      {...test}
                      values={values}
                      selected={
                        values.testTypeId == test.id ||
                        values.secondaryTestId == test.id
                      }
                      handleFav={() =>
                        handleFav(
                          !!favTests?.data?.find?.(
                            (favTest) => favTest.id === test.id
                          ),
                          test.id
                        )
                      }
                      isFavorite={
                        !!favTests?.data?.find?.(
                          (favTest) => favTest.id === test.id
                        )
                      }
                      handleSelection={handleSelection(test)}
                    />
                  );
                })}
              </div>
            </CustomAccordion>
          ))}
        </div>
      </div>
      {showPopup && (
        <CustomPopUp
          hidePopUp={() => setShowPopup(false)}
          popUpTitle={"Test Submission"}
          hideClose={false}
          onlineOrder={true}
        >
          <p className="mt-5 text-royalBlue">
            It seems that you already have a test order in-progress or in
            pending submission for this patient.
          </p>
          <p className="mb-2 text-royalBlue">
            Please change test type in order to proceed further
          </p>

          <div className="flex items-center justify-end">
            <Button
              textInformation={{
                text: "Go Back To Table",
                fontWeight: "font-semibold",
              }}
              onClick={() => {
                history.replace("/access/test-orders");
              }}
              buttonTheme="secondary"
            />
            <Button
              textInformation={{
                text: "Go To Existing Test",
                fontWeight: "font-semibold",
              }}
              onClick={() => {
                history.replace(`/access/test-orders/summary/${orderId}`);
              }}
              buttonTheme="secondary"
              className="mx-2"
            />
            <Button
              textInformation={{
                text: "Stay",
                fontWeight: "font-semibold",
              }}
              onClick={() => {
                setFieldValue("testTypeId", "");
                setShowPopup(false);
              }}
              buttonTheme="primary"
            />
          </div>
        </CustomPopUp>
      )}
      {showDuplicatePopup && (
        <CustomPopUp
          hidePopUp={() => {
            setFieldValue("isPotentialDuplicateOrder", false);
            setShowDuplicatePopup(false);
          }}
          popUpTitle={"Potential Duplicate Detected"}
          hideClose={false}
          onlineOrder={true}
        >
          <p className="mt-5 text-royalBlue">
            A potential duplicate order was detected for this patient and test selection.
          </p>
          <p className="mb-2 text-royalBlue">
            If this is a different order, please confirm to continue.
          </p>

          <div className="flex items-center justify-end">
            <Button
              textInformation={{
                text: "CONTACT SUPPORT",
                fontWeight: "font-semibold",
              }}
              onClick={sendSupportEmail}
              buttonTheme="secondary"
            />
            <Button
              textInformation={{
                text: "I confirm this is a separate order",
                fontWeight: "font-semibold",
              }}
              onClick={() => {
                setFieldValue("isPotentialDuplicateOrder", true);
                setShowDuplicatePopup(false);
              }}
              buttonTheme="primary"
              className="mx-2"
            />
          </div>
        </CustomPopUp>
      )}
    </Fragment>
  );
}

export default SelectTestStep;
